import type { WorkSpace } from 'features/workspace'

import './style.scss'

import clsx from 'clsx'

import type { Day } from './utils'

import DateInput from '../../atoms/DateInput'

export const DateSelection = ({
	className,
	dateSelectionHandler,
	dayOfWeek,
	handleDateChange,
	hours
}: {
	className?: string
	dateSelectionHandler: (day: WorkSpace.WeekDayName) => void

	dayOfWeek: WorkSpace.WeekDayName
	handleDateChange: (day: WorkSpace.WeekDayName, value: string) => void

	hours: Day
}) => (
	<div
		className={clsx('date-selection', className, {
			'date-selection-error': hours.errorMessage.length && hours.isSelected
		})}
	>
		<label className='container-label'>
			<input
				checked={hours.isSelected}
				onChange={() => dateSelectionHandler(dayOfWeek)}
				type='checkbox'
			/>
			<span className='data-text'>
				{dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1)}
			</span>
		</label>
		<DateInput
			day={dayOfWeek}
			disabled={!hours.isSelected}
			errorMessage={hours.errorMessage}
			handleDateChange={handleDateChange}
			value={hours.value}
		/>
	</div>
)
